import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { AppProviders } from '@/app/providers/AppProviders'
import { router } from '@/app/router/router'
import { prefetchModelCatalog } from '@/entities/ai-model'

export function bootstrap() {
  void prefetchModelCatalog()
  const root = document.getElementById('root')
  if (!root) throw new Error('Root element not found')
  createRoot(root).render(<StrictMode><AppProviders><Suspense fallback={<main className="route-state"><p>正在加载工作台…</p></main>}><RouterProvider router={router} /></Suspense></AppProviders></StrictMode>)
}
